'use strict';

/**
 *  Module 网站专题模板
 *  creatyBy SMG
 *  Description
 */
angular.module('websiteSubjectModule', []).controller('editingCenterWebsiteSubjectCtrl', [
    '$scope',
    '$element',
    'iWoService',
    '$compile',
    'beforeonload',
    '$rootScope',
    '$sce',
    '$timeout',
    '$q',
    '$state',
    '$validation',
    '$window',
    '$filter',
    'initWebsiteDataService',
    'initWebsiteNewsService',
    'initeditctrBtnsService',
    'websiteBtnService',
    'filterEditctrBtnsService',
    'trsHttpService',
    'initVersionService',
    'modalDialog',
    'jsonArrayToStringService',
    'editingCenterService',
    'storageListenerService',
    'editIsLock',
    'Upload',
    'websiteService',
    'trsSelectDocumentService',
    'trsspliceString',
    'localStorageService',
    'sensitiveWordCheckService',
    'editcenterRightsService',
    'heimaCheckService',
    'newMediaService',
    'websiteConst',
    'messagePublishService',
    function(
        $scope,
        $element,
        iWoService,
        $compile,
        beforeonload,
        $rootScope,
        $sce,
        $timeout,
        $q,
        $state,
        $validation,
        $window,
        $filter,
        initWebsiteDataService,
        initWebsiteNewsService,
        initeditctrBtnsService,
        websiteBtnService,
        filterEditctrBtnsService,
        trsHttpService,
        initVersionService,
        modalDialog,
        jsonArrayToStringService,
        editingCenterService,
        storageListenerService,
        editIsLock,
        Upload,
        websiteService,
        trsSelectDocumentService,
        trsspliceString,
        localStorageService,
        sensitiveWordCheckService,
        editcenterRightsService,
        heimaCheckService,
        newMediaService,
        websiteConst,
        messagePublishService
    ) {
        initStatus();
        initData();
        websiteService.addFuture($scope, ['sendmessage']);


        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.params = {
                serviceid: 'mlf_website',
                methodname: 'getSpecialDoc',
                ChnlDocId: $state.params.wzchnldocid,
                ChannelId: $state.params.wzchannelid,
                SiteId: $state.params.wzsiteid,
                MetaDataId: $state.params.wzmetadataid,
            };
            $scope.status = {
                groupNewsPage: {
                    CURRPAGE: 1,
                    PAGESIZE: 50,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 0,
                },
                timeScreen: '',
                timeShowFlag: '',
                newsFormError: [],
                websiteAscription: $state.params.wzmetadataid === undefined ? 'false' : 'true', // 判断是否是新建 新建情况下才女战士归属人
                switch: 'manuscriptInfo', // 默认选中稿件信息
                openBtn: true,
                files: [], // 上传附件绑定数组
                showFiles: [], // 附件展示以及上传字段
                isUploaderFile: false, // 上传按钮是否可点击
                tag: {
                    currTagId: '',
                    currTagIndex: '',
                    tagArray: [],
                    newTagName: '',
                    currDraftId: '',
                    dragStartIndex: '',
                    draftOriginalName: '',
                },
                position: $state.params.wzplatform,
                isEdit: angular.isDefined($state.params.wzchnldocid),
                isCheckSensitiveWords: false,
                sensitiveWordTit: '敏感词校验',
                heimaCheckTit: '错别字校对',
                isawaitrevise: $state.params.isawaitrevise,
                pictureSize: '',
                picRatio: 0,
                isSearch: false,
            };
            $scope.data = {
                userName: '',
                version: [],
                copyVersion: [],
                versionTime: [],
                copyDraft: [],
                copyDraftLog: [],
                Channel: [],
                voiceObj: {},
                trench: websiteConst.listenStroageKey,
                relNewsSelectedItems: [],
                ownerSelectedItems: '',
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                moveMethodName: {
                    0: 'moveDAIBIANDoc',
                    1: 'moveDAISHENDoc',
                    2: 'moveYIQIANFADoc',
                },
                deleteSpecialGroupIds: '' // 被删除的分组id，在保存或关闭时都要传给后台
            };
            emitCloseWindow();
            $scope.editFlag = {
                media: 'website',
                docType: 'subject',
            };
            $scope.keywords = '';
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.subjectForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        // /**
        //  * [downRecord description]分组下移
        //  * @return {[type]} [description]
        //  */
        $scope.groupMoveRecord = function(e, group, direction, index, trueIndex) {
            e.stopPropagation();
            if (trueIndex) {
                upAndDownMove(direction, group, index, trueIndex);
            } else {
                upAndDown(direction, group);
            }
            recordGroupOrder();
        };

        /**
         * [recordGroupOrder description]记录分组顺序
         * @return {[type]} [description]
         */
        function recordGroupOrder() {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'addSpecialGroups',
                MetaDataId: $scope.list.METADATAID,
                mediaType: 2,
                SpecialGroupIds: trsspliceString.spliceString($scope.status.tag.tagArray, 'SPECIALGROUPID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                deferred.resolve();
            });
            return deferred.promise;
        }

        /**
         * [upAndDown description]数组上移下移
         * @param  {[str]} type      [description]上移或者下移
         * @param  {[str]} attribute [description]要改变的数组
         * @param  {[obj]} select    [description]被选中的值
         * @return {[type]}           [description]
         */
        function upAndDown(type, select) {
            var index = $scope.status.tag.tagArray.indexOf(select);
            if (type === 'up') {
                if (index === 0) {
                    return;
                }
                $scope.status.tag.tagArray.splice(index, 1);
                $scope.status.tag.tagArray.splice(index - 1, 0, select);
            } else if (type === 'down') {
                if (index === $scope.status.tag.tagArray.length) {
                    return;
                }
                $scope.status.tag.tagArray.splice(index, 1);
                $scope.status.tag.tagArray.splice(index + 1, 0, select);
            }
        }

        // /**
        //  * [upAndDown description]数据滑动上移或者下移
        //  * @param  {[str]} type      [description]上移或者下移
        //  * @param  {[str]} attribute [description]要改变的数组
        //  * @param  {[obj]} select    [description] index 改变前的值  trueIndex 改变后的值
        //  * @return {[type]}           [description]
        //  */
        function upAndDownMove(type, select, index, trueIndex) {
            if (type === 'up') {
                if (index === 0) {
                    return;
                }
                $scope.status.tag.tagArray.splice(index, 1);
                $scope.status.tag.tagArray.splice(trueIndex, 0, select);
            } else if (type === 'down') {
                if (index === $scope.status.tag.tagArray.length) {
                    return;
                }
                $scope.data[attribute].splice(index, 1);
                $scope.data[attribute].splice(trueIndex, 0, select);
            }
        }

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            window.onbeforeunload = function() {
                localStorageService.set('saveSubjectInnerLog', JSON.stringify({
                    specialGroupIds: $scope.status.tag.tagArray.length > 0 ? !$scope.data.deleteSpecialGroupIds ? trsspliceString.spliceString($scope.status.tag.tagArray, 'SPECIALGROUPID', ',') : trsspliceString.spliceString($scope.status.tag.tagArray, 'SPECIALGROUPID', ',') + ',' + $scope.data.deleteSpecialGroupIds : $scope.data.deleteSpecialGroupIds,
                    METADATAID: $scope.list.METADATAID
                }));
                localStorageService.set(
                    'unLocakDraft',
                    JSON.stringify({
                        metadataid: $state.params.wzmetadataid,
                    }),
                );
                // if (!$scope.list.METADATAID) {
                //     var specialGroupIds = getUnsaveSpecialGroupIds();
                //     localStorageService.set('websiteUnsavedGroup', {
                //         specialGroupIds: specialGroupIds,
                //         metadataid: $scope.list.METADATAID,
                //     });
                // }
            };
        }

        /**
         * [getUnsaveSpecialGroupIds description] 获取未保存的分组id
         * @return {[type]} [description]
         */
        function getUnsaveSpecialGroupIds() {
            return trsspliceString.spliceString($scope.status.tags.filter(function(group) {
                return group.METADATAID === "0";
            }).join(','),'SPECIALGROUPID', ',');
        }

        function initData() {
            $scope.handleBtnClick = function(funname) {
                eval('$scope.' + funname + '()');
            };
            // 判断是否有修订完成权限
            if ($scope.status.isawaitrevise) {
                editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function(rights) {
                    $scope.status.btnRights = rights;
                });
            }
            // 判断是否存在chnldocid,存在则执行编辑数据,否则就是新建数据
            (angular.isDefined($state.params.wzchnldocid) ? initEditData() : initNewData()).then(function() {
                beforeonload.beforeonloadAlert($scope); // 关闭窗口监听，检查页面是否修改，让用户确认是否保存
            });
            // 非融合编辑器的裁剪功能
            getCutPictureWidthHeight();
        }

        /**
         * [visualChooseWindow description]可视化选择
         * @return {[type]} [description]
         */
        $scope.visualChooseWindow = function() {
            trsSelectDocumentService.trsSelectDocumentForST(
                {
                    siteid: $state.params.wzsiteid,
                    relNewsData: angular.copy($scope.data.relNewsSelectedItems),
                    position: $state.params.wzplatform,
                    showMetadaId: true,
                },
                function(result) {
                    angular.forEach(result, function(value, key) {
                        value.METADATAID = value.metadataId;
                        value.TITLE = value.title;
                    });
                    $scope.data.relNewsSelectedItems = result;
                },
            );
        };

        /**
         * [getCutPictureWidthHeight description]获取图片编辑默认宽高
         * @return {[type]} [description]
         */
        function getCutPictureWidthHeight() {
            editingCenterService.querySettedPicSize('website').then(function(data) {
                $scope.status.pictureSize = websiteService.resetPicSize(data.OutLinePicSize);
            });
        }

        /**
         * [initEditData description]初始化编辑数据
         * @return {[type]} [description]
         */
        function initEditData() {
            var deffer = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'get').then(function(data) {
                $scope.list = data;
                $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                $scope.list.serviceid = 'mlf_website';
                $scope.list.methodname = 'saveSpecialDoc';
                $scope.list.CHNLDOCID = $state.params.wzchnldocid;
                // $scope.list.OUTLINEPICS = doWithPicsOrAttach($scope.list.OUTLINEPICS);
                document.title = $scope.list.TITLE = $scope.list.TITLE.split('<br />').join('\n');
                initBtnArray();
                getChannel();
                reWriteAttachFile(data);
                initDocgenre(data);
                resolveOUTLINEPIC(); // 编辑稿件时添加加号
                loadDirective();
                // 初始化责任编辑
                // getCurrentLoginUser().then(function(name) {
                //     $scope.list.EDITORTRUENAME = $scope.list.EDITORTRUENAME ? $scope.list.EDITORTRUENAME : name[0].TRUENAME;
                // });
                // 获取流程版本
                // getVersion();
                getComment($state.params.wzmetadataid, $scope.data.comment.currPage);
                deffer.resolve();
            });
            // 稿件加锁
            editIsLock.lockDraft($state.params.wzmetadataid);
            // 稿件的标签列表
            requestTagList().then(function() {
                if ($scope.status.tag.tagArray.length > 0) {
                    $scope.status.tag.currTagId = $scope.status.tag.tagArray[0].SPECIALGROUPID;
                    $scope.status.tag.currTagIndex = 0;
                    requestTagDraftList(1);
                }
            });
            return deffer.promise;
        }

        function initNewData() {
            var deffer = $q.defer();
            $scope.list = initWebsiteDataService.initSubject();
            $scope.list.CHANNELID = $state.params.wzchannelid;
            $scope.list.methodname = 'saveSpecialDoc';
            initBtnArray();
            getChannel();
            initDocgenre();
            loadDirective();
            deffer.resolve();
            return deffer.promise;
        }

        // 初始化底部功能按钮
        function initBtnArray() {
            if ($scope.status.isawaitrevise) {
                // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                addBtn();
                return;
            }
            // 所需权限初始化
            $scope.webSiteBtns = initWebsiteNewsService.initWebSitedBtns()[$state.params.wzplatform];
            // 查询权限方法
            $scope.methodArrary = ['web.daibian', 'web.daishen', 'web.yiqianfa'];
            initeditctrBtnsService.initWebsiteData($state.params.wzchannelid, $scope.methodArrary[$state.params.wzplatform]).then(function(data) {
                $scope.dictionaryBtn = [websiteBtnService.initWebCompBtn(), websiteBtnService.initWebPenBtn(), websiteBtnService.initSingBtn()];
                initeditctrBtnsService.initBtns(data, $scope.dictionaryBtn[$state.params.wzplatform]).then((btns)=>{
                    $scope.btnStatus = btns;
                    $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.webSiteBtns);
                    addBtn();
                });
            });
        }

        /**
         * [resolveOUTLINEPIC description]编辑稿件时添加加号
         * @return
         */
        function resolveOUTLINEPIC() {
            if (!$scope.list.OUTLINEPICS) {
                $scope.list.OUTLINEPICS = [];
            }
            $scope.list.OUTLINEPICS.push({
                APPFILE: '',
                APPDESC: '',
                PERPICURL: '',
            });
        }

        // 新增预览与关闭按钮
        function addBtn() {
            $scope.arrayBtn = $scope.arrayBtn ? $scope.arrayBtn : [];
            angular.forEach($scope.arrayBtn, function(data, index) {
                if (data.RIGHTINDEX == '496') {
                    // 专题稿件去除二次审核
                    $scope.arrayBtn.splice(index, 1);
                }
            });
            if ($state.params.wzplatform == 2) {
                return;
            }
            var OPERDESC = ['保存', '保存'];
            var OPERFUN = ['save', 'save'];
            $scope.arrayBtn.unshift({
                RIGHTINDEX: 'save',
                OPERDESC: OPERDESC[$state.params.wzplatform],
                OPERNAME: '',
                OPERFUN: OPERFUN[$state.params.wzplatform],
            });
            // $scope.arrayBtn.push({
            //     RIGHTINDEX: "close",
            //     OPERDESC: "关闭",
            //     OPERNAME: "",
            //     OPERFUN: "close"
            // });
        }

        /* 点击保存*/
        $scope.save = function() {
            var defer = $q.defer();
            save(true).then(function() {
                editIsLock.lockDraft($state.params.wzmetadataid);
                getVersion();
                if (angular.isDefined($state.params.wzchnldocid)) {
                    var params = {
                        serviceid: 'mlf_website',
                        methodname: 'getSpecialDoc',
                        ChnlDocId: $state.params.wzchnldocid,
                        ChannelId: $state.params.wzchannelid,
                        SiteId: $state.params.wzsiteid,
                        MetaDataId: $state.params.wzmetadataid,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                        reWriteAttachFile(data);
                    });
                }
                defer.resolve();
            }, function() {
                defer.reject();
            });
            return defer.promise;
        };

        /* 保存并送审*/
        $scope.webCompileSend = function() {
            saveSend();
        };

        /* 待编平台直接签发*/
        $scope.webCompileSignDirect = function() {
            let params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'webDaiBianPublish',
            };
            singDirect(params);
        };

        /* 待编平台定时签发*/
        $scope.webCompileSignTiming = function() {
            singTiming();
        };

        /* 待审平台直接签发*/
        $scope.webPendingSignDirect = function() {
            // save().then(function(data) {
            // $scope.params.serviceid = 'mlf_websiteoper';
            // $scope.params.methodname = 'webDaiShenPublish';
            let params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'webDaiShenPublish',
            };
            singDirect(params);
            // });
        };

        /* 待审平台定时签发*/
        $scope.webPendingSignTiming = function() {
            singTiming();
        };

        /* 待审平台退稿*/
        $scope.webPendingKill = function() {
            rejection();
        };

        /* 已签发平台保存并发布*/
        $scope.webSignPublish = function() {
            // save().then(function(data) {
            // $scope.params.serviceid = 'mlf_websiteoper';
            // $scope.params.methodname = 'webYiQianPublish';
            let params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'webYiQianPublish',
            };
            singDirect(params, true);

            // });
        };

        /**
         * [close description]页面关闭
         * @return {[type]} [description]
         */
        $scope.close = function() {
            editingCenterService.closeWinow($scope.subjectForm.$dirty, false).then(
                function() {
                    save().then(function() {
                        storageListenerService.addListenerToWebsite('save');
                        editIsLock.normalLock($state.params.wzmetadataid).then(function(data) {
                            $window.close();
                        });
                    });
                },
                function() {
                    // clearDirtyTag(); // 清除未和专题关联的标签
                    angular.isDefined($state.params.wzmetadataid)
                        ? editIsLock.normalLock($state.params.wzmetadataid).then(function(data) {
                            $window.close();
                        })
                        : $window.close();
                },
            );
        };

        /* 预览*/
        $scope.preview = function() {
            // modalDialog.isSecretInformation($state.params.wzmetadataid,function() {
            save().then(function(data) {
                editIsLock.lockDraft($state.params.wzmetadataid);
                preview();
            });
            // }, function() {});
        };

        // 保存预览
        function preview() {
            editingCenterService.draftPublish($state.params.wzchnldocid);
        }

        /**
         * [revise description] 修订
         * @return {[type]} [description]
         */
        $scope.revise = function() {
            modalDialog.confirmModal('修订', '确认修订?', function() {
                save().then(
                    function() {
                        var params = {
                            serviceid: 'mlf_modifydoc',
                            methodname: 'paperModifyDocsFinished',
                            PaperDocIds: $statearaPms.wzmetadataid,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function(data) {
                                modalDialog.alertType(
                                    '修订成功',
                                    '',
                                    'success',
                                    false,
                                    function() {
                                        storageListenerService.addListenerToNewspaper('xiuding');
                                        $window.close();
                                    },
                                    '',
                                    1500,
                                );
                            },
                            function(data) {
                                editIsLock.lockDraft($state.params.wzmetadataid);
                            },
                        );
                    },
                    function() {
                        editIsLock.lockDraft($state.params.wzmetadataid);
                    },
                );
            });
        };

        /**
         * [manageDataAtferSave description]保存后数据处理
         * @param  {[type]} data [description]保存后返回的数据
         * @param  {[type]} flag [description]标识
         * @return {[type]}      [description]
         */
        function manageDataAtferSave(data, flag) {
            $scope.status.openBtn = true;
            $scope.list.METADATAID = data.METADATAID;
            $scope.list.CHNLDOCID = data.CHNLDOCID;
            $state.params.wzmetadataid = angular.isDefined($state.params.wzmetadataid) ? $state.params.wzmetadataid : data.METADATAID;
            $state.params.wzchnldocid = angular.isDefined($state.params.wzchnldocid) ? $state.params.wzchnldocid : data.CHNLDOCID;
            $state.params.wzchannelid = angular.isDefined($state.params.wzchannelid) ? $state.params.wzchannelid : $scope.list.CHANNELID;
            if (flag) {
                storageListenerService.addListenerToWebsite('save');
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                $timeout(function() {
                    modalDialog.saveModel('保存成功', '', 'success');
                }, 500);
            } else {
                $scope.params = {
                    MetaDataIds: $state.params.wzmetadataid,
                    CHNLDOCIDS: $state.params.wzchnldocid,
                    ObjectIds: $state.params.wzchnldocid,
                    ChannelId: $state.params.wzchannelid,
                    serviceid: 'mlf_websiteoper',
                };
            }
        }

        function save(flag) {
            // flag用于调用保存服务后是否弹出成功窗口判断
            var deferred = $q.defer();
            if (!$scope.status.tag.tagArray.length) {
                modalDialog.alertType('分组标签内容不可为空', '', 'info');
                deferred.reject();
                return deferred.promise;
            }
            $timeout(function() {
                $validation.validate($scope.subjectForm.authorForm);
                $scope.subjectForm.$pending = {};
                $validation
                    .validate($scope.subjectForm)
                    .success(function() {
                        modalDialog.isSecretInformation(
                            $state.params.wzmetadataid,
                            function() {
                                sensitiveWordCheckService.sensitiveWords($scope).then(
                                    function(sensitiveWords) {
                                        $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                        $scope.list.SENSITIVEWORDS = sensitiveWords;
                                        $scope.subjectForm.$setPristine();
                                        $scope.status.openBtn = false;
                                        var list = dealAttribute();
                                        $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', list, 'post').then(
                                            function(data) {
                                                manageDataAtferSave(data, flag);
                                                beforeonload.refresh($scope);
                                                saveSort().then(function() {
                                                    deferred.resolve(data);
                                                }, function() {
                                                    deferred.resolve(data);
                                                });
                                            },
                                            function(data) {
                                                $scope.status.openBtn = true;
                                                deferred.reject(data);
                                            },
                                        );
                                    },
                                    function() {
                                        $scope.status.isCheckSensitiveWords = Math.random();
                                    },
                                );
                            },
                            function() {
                            },
                        );
                    })
                    .error(function() {
                        editingCenterService.checkSaveError($scope.subjectForm, $element, $scope); // 定位输入错的表单位置
                    });
            }, 100);
            return deferred.promise;
        }

        /**
         * [saveSort description] 保存顺序
         *
         * @return  {[type]}   [return description]
         */
        function saveSort() {
            const defer = $q.defer();
            const params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'orderSpecialGroupNews',
                METADATAID: $scope.list.METADATAID,
                mediaType: 2,
                SpecialGroupID: $scope.status.tag.currTagId,
                OrderBy: $scope.status.timeShowFlag
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                defer.resolve();
            }, function() {
                defer.reject();
            });
            return defer.promise;
        }

        /**
         * [saveChannelInfo description] 保存稿件的栏目信息
         * @return {[type]} [description]
         */
        function saveChannelInfo(data_2) {
            $scope.CHANNEL = data_2[0].CHANNELPATH;
            $scope.list.CHANNELID = data_2[0].CHANNELID;
            template($scope.list.CHANNELID);
        }

        function template(channelid) {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'getOptionalTemplates',
                ObjectType: '101',
                ObjectId: channelid,
                TEMPLATETYPE: '2',
                DocTemp: true,
            };
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post').then(function(data) {
                var templateJson = data.DATA;
                var channel = [];
                channel.push({
                    name: '请选择模板',
                    value: 0,
                });
                for (var key in templateJson) {
                    channel.push({
                        name: templateJson[key].TEMPNAME,
                        value: parseInt(templateJson[key].TEMPID),
                    });
                    if (templateJson[key].DEFAULTTEMP == 1 && !$state.params.wzchnldocid) {
                        $scope.list.TEMPNAME = {
                            name: templateJson[key].TEMPNAME,
                            value: templateJson[key].TEMPID,
                        };
                    }
                }
                $scope.templateJson = channel;
                deferred.resolve($scope.templateJson);
            });
            return deferred.promise;
        }

        /**
         * [dealAttribute description]处理保存时对象属性问题
         * @return {[type]} [description]
         */
        function dealAttribute() {
            saveAttachFile();
            filterTime();
            var list = angular.copy($scope.list);
            list.RELATEDNEWS = trsspliceString.spliceString($scope.data.relNewsSelectedItems, 'METADATAID', ',');
            list.OUTLINEPICS = angular.copy(jsonArrayToStringService.clearEmptyObjects(list.OUTLINEPICS, 'APPFILE'));
            // 标题回车处理成</br> 存入数据库里
            list.TITLE = list.TITLE.split('\n').join('<br />');
            // 供稿作者
            list.CONTRIBUTORSAUTHER = $scope.data.userName;
            // 与专题关联的标签ID
            // if (!$scope.list.METADATAID) {
            list.SpecialGroupIds = $scope.status.tag.tagArray.length > 0 ? !$scope.data.deleteSpecialGroupIds ? trsspliceString.spliceString($scope.status.tag.tagArray, 'SPECIALGROUPID', ',') : trsspliceString.spliceString($scope.status.tag.tagArray, 'SPECIALGROUPID', ',') + ',' + $scope.data.deleteSpecialGroupIds : $scope.data.deleteSpecialGroupIds;
            // }
            // 稿件归属人
            list.OWNER = trsspliceString.spliceString($scope.data.ownerSelectedItems, 'USERID', ',');
            list = jsonArrayToStringService.jsonArrayToString(list);
            return list;
        }

        /**
         * [filterTime description]时间过滤
         * @return {[type]} [description]
         */
        function filterTime() {
            if (angular.isObject($scope.list.CUSTOMTIME)) {
                $scope.list.CUSTOMTIME = $filter('date')($scope.list.CUSTOMTIME, 'yyyy-MM-dd HH:mm').toString();
            }
        }

        /* 保存送审函数*/
        function saveSend() {
            newMediaService.trial($scope, websiteConst.trial).then((opinion) => {
                save().then(function() {
                    $scope.params.METADATAID = $scope.list.METADATAID;
                    $scope.params.CurrChnlId = $state.params.wzchannelid;
                    $scope.params.opinion = opinion;
                    let trialParams = angular.extend($scope.params, websiteConst.trial);
                    messagePublishService.publish('doEditPageOperation', trialParams);
                });
            });

            // modalDialog.inputModel(
            //     '送审',
            //     '确定送审吗？',
            //     function(content) {
            //         $scope.params.Opinion = content;
            //         $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'post', false).then(
            //             function(dataC) {
            //                 modalDialog.alertType(
            //                     '送审成功',
            //                     '',
            //                     'success',
            //                     false,
            //                     function() {
            //                         storageListenerService.addListenerToWebsite('send');
            //                         $window.close();
            //                     },
            //                     '',
            //                     1500,
            //                 );
            //             },
            //             function() {
            //                 editIsLock.lockDraft($state.params.wzmetadataid);
            //             },
            //         );
            //     },
            //     '',
            //     function() {
            //         editIsLock.lockDraft($state.params.wzmetadataid);
            //     },
            // );
        }

        /* 直接签发函数*/
        function singDirect(params, isSaveAndPublish) {
            var array = [$scope.list];
            if (isSaveAndPublish) {
                privateSign(params);
                // mergeSign();
            } else {
                sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, 2).then(
                    function() {
                        privateSign(params);
                    },
                    function() {
                        privateSign(params);
                        // mergeSign();
                    },
                );
            }

            function privateSign(params) {
                $scope.loadingPromise = newMediaService.sign($scope).then(function() {
                    save().then(function(data) {
                        messagePublishService.publish('doEditPageOperation', angular.extend($scope.params, params));
                    });
                });
                // 将post换成get
                // $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'get', false).then(
                //     function(dataC) {
                //         modalDialog.alertType(
                //             '直接签发成功',
                //             '',
                //             'success',
                //             false,
                //             function() {
                //                 storageListenerService.addListenerToWebsite('directSign');
                //                 $window.close();
                //             },
                //             '',
                //             1500,
                //         );
                //     },
                //     function() {
                //         editIsLock.lockDraft($state.params.wzmetadataid);
                //     },
                // );
            }

            function mergeSign() {
                modalDialog.confirmModal(
                    '签发',
                    '确认直接签发?',
                    function() {
                        privateSign();
                    },
                    function() {
                        editIsLock.lockDraft($state.params.wzmetadataid);
                    },
                );
            }

            /* modalDialog.confirmModal('签发', '确认发布稿件', function() {
                $scope.loadingPromise = trsHttpService.httpServer("/wcm/mlfcenter.do", $scope.params, "post", false).then(function(dataC) {
                    modalDialog.alertType("直接签发成功", "", "success", false,
                        function() {
                            storageListenerService.addListenerToWebsite("directSign");
                            $window.close();
                        }, "", 1500);
                }, function() {
                    editIsLock.lockDraft($state.params.wzmetadataid);
                });
            }, function() {
                editIsLock.lockDraft($state.params.wzmetadataid);
            });*/
        }

        /* 定时签发函数*/
        function singTiming() {
            var methodname = ['webDaiBianTimingPublish', 'webDaiShenTimingPublish'];
            $scope.loadingPromise = newMediaService.timeSign($scope).then(function () {
                save().then(() => {
                    let signParams = {
                        serviceid: 'mlf_websiteoper',
                        methodname: methodname[$state.params.wzplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        // 退稿函数
        function rejection() {
            newMediaService.rejection($scope, websiteConst.rejection).then((opinion) => {
                save().then(function() {
                    $scope.params.Opinion = opinion;
                    $scope.params.CHNLDOCIDS = $state.params.wzchnldocid;
                    let KillParams = angular.extend($scope.params, websiteConst.rejection);
                    messagePublishService.publish('doEditPageOperation', KillParams);
                });
            });
            // modalDialog.inputModel(
            //     '是否确认撤稿',
            //     '撤稿原因(可选)',
            //     function(content) {
            //         $scope.params.Opinion = content;
            //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get', false).then(
            //             function() {
            //                 modalDialog.alertType(
            //                     '撤稿成功',
            //                     '',
            //                     'success',
            //                     false,
            //                     function() {
            //                         storageListenerService.addListenerToWebsite('reject');
            //                         $window.close();
            //                     },
            //                     '',
            //                     1500,
            //                 );
            //             },
            //             function() {
            //                 editIsLock.lockDraft($state.params.wzmetadataid);
            //             },
            //         );
            //     },
            //     '',
            //     function() {
            //         editIsLock.lockDraft($state.params.wzmetadataid);
            //     },
            // );
        }

        // 编辑中，初始化处理图片或者附件
        function doWithPicsOrAttach(array) {
            // 处理READINGPICS字段为空数组的情况，防止相关图片框消失。
            if (array.length === 0) {
                array = [
                    {
                        APPFILE: '',
                        APPDESC: '',
                    },
                ];
            }
            return array;
        }

        /** ********************************************附件上传开始**********************************************/
        /**
         * [selectFiles description]选择文件
         * @param  {[type]} files    [description]所有文件
         * @param  {[type]} file     [description]
         * @param  {[type]} newFiles [description]新增的文件
         * @return {[type]}          [description]
         */
        $scope.selectFiles = function(files, file, newFiles) {
            $scope.status.isUploaderFile = true;
            angular.forEach(newFiles, function(value, key) {
                var fileType = value.name
                    .split('.')
                    .pop()
                    .toLowerCase();
                // 只能上传.zip类型的文档
                if (fileType == 'zip') {
                    $scope.status.showFiles = [
                        {
                            SRCFILE: newFiles[key].name,
                            APPDESC: newFiles[key].name,
                            FILEINFO: '等待上传',
                            FILE: newFiles[key],
                        },
                    ];
                    $scope.fileSubmit();
                } else {
                    modalDialog.alertType('请选择.zip类型的文档', '', 'warning', false);
                }
            });
        };

        /**
         * [getAttachFile description]为SPECIALFILE重新复制，可更改并删除多余字段
         * @return {[type]} [description]null
         */
        function saveAttachFile() {
            $scope.list.SPECIALFILE = [];
            angular.forEach($scope.status.showFiles, function(value, key) {
                if (value.FILEINFO === '上传成功') {
                    delete value.FILE;
                    delete value.PICURL;
                    delete value.PERPICURL;
                    delete value.APPENDIXID;
                    delete value.APPDOCID;
                    $scope.list.SPECIALFILE.push(value);
                }
            });
        }

        /**
         * [reWriteAttachFile description]附件字段回写
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function reWriteAttachFile(data) {
            $scope.status.showFiles = angular.copy(data.ATTACHFILE);
            angular.forEach($scope.status.showFiles, function(value, key) {
                value.FILEINFO = '上传成功';
            });
        }

        /**
         * [fileSubmit description]附件提交
         * @return {[type]} [description]
         */
        $scope.fileSubmit = function() {
            if (angular.isUndefined($scope.subjectForm.$error.filename)) {
                if ($scope.status.showFiles) {
                    angular.forEach($scope.status.showFiles, function(file, key) {
                        if (file.FILEINFO === '等待上传') {
                            Upload.upload({
                                url: '/wcm/openapi/uploadFile',
                                data: {
                                    file: file.FILE,
                                },
                            }).then(
                                function(resp) {
                                    if (resp.data.success) {
                                        file.FILEINFO = '上传成功';
                                        file.APPFILE = resp.data.imgName;
                                        file.url = resp.data.imgSrc;
                                    } else if (resp.data.error) {
                                        file.FILEINFO = '上传失败';
                                    }
                                },
                                function(resp) {
                                },
                                function(evt) {
                                    // file.progressPercentage = parseInt(100.0 * evt.loaded / evt.total) + '%';
                                    file.FILEINFO = '上传中';
                                },
                            );
                            $scope.status.isUploaderFile = false;
                        }
                    });
                }
            } else {
                modalDialog.saveModel('附件上传失败', '附件填写有误', 'error', 'confirm');
            }
        };

        /**
         * [removeCurFile description]移除当前附件
         * @param  {[obj]} file  [description]被选中的附件
         * @param  {[num]} index [description]附件下标
         * @return {[type]}       [description]
         */
        $scope.removeCurFile = function(file, index) {
            $scope.status.showFiles.splice($scope.status.showFiles.indexOf(file), 1);
        };

        /** ********************************************附件上传结束*************************************************/

        /**
         * [addUploaderImg description]导读，概览图片上传
         * @param {[type]} array [description]
         */
        $scope.addUploaderImg = function(array, type) {
            if (array.length > 9) {
                modalDialog.alertType(type + '最多支持10张', '', 'error', 'confirm');
                return;
            }
            array.push({
                APPFILE: '',
                APPDESC: '',
                PERPICURL: '',
            });
        };

        /**
         * [uploadImg description]导读，概览图片上传
         * @param {[type]} array [description]
         */
        $scope.uploadImg = function() {
            if ($scope.list.OUTLINEPICS[$scope.list.OUTLINEPICS.length - 1].relationId) {
                $scope.list.OUTLINEPICS.push({
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                });
            }
        };
        $scope.deleteImgContainer = function(item, array) {
            array.splice(array.indexOf(item), 1);
        };

        // 根据栏目ID获取栏目名称
        function getChannel() {
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'getChannelPath',
                ChannelId: $state.params.wzchannelid,
                Burster: '>',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.CHANNEL = data.replace(/\"/g, '');
            });
        }

        /** ****************************标签管理开始********************************/
        /**
         * [requestTagList description]请求标签列表
         */
        function requestTagList() {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'querySpecialGroupsFromData',
                MetaDataId: angular.isDefined($state.params.wzchnldocid) ? $state.params.wzmetadataid : '0',
                mediaType: 2,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.tag.tagArray = data.DATA;
                deferred.resolve();
            });
            return deferred.promise;
        }

        /**
         * [requestTagDraftList description]请求标签下稿件的列表
         *
         * @param  {[type]}  page   [page description]
         *
         * @return  {[type]}   [return description]
         */
        function requestTagDraftList(page) {
            page = page || $scope.status.groupNewsPage.CURRPAGE;
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'querySpecialGroupNewsFromGroup',
                SpecialGroupID: $scope.status.tag.currTagId,
                mediaType: 2,
                CurrPage: page,
                PageSize: $scope.status.groupNewsPage.PAGESIZE,
                searchWord: $scope.keywords,
                OrderBy: $scope.status.timeShowFlag
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.groupNews = data instanceof Object ? data.DATA : data;
                $scope.data.groupNews = $filter('unique')($scope.data.groupNews, 'NEWSSPECIALDATAID');
                angular.forEach($scope.data.groupNews, function(data) {
                    data.METADATAID = data.NEWSSPECIALDATAID;
                    data.TITLE = data.DOCTITLE;
                });
                if (!$scope.status.isSearch) {
                    $scope.data.itemTotal = data.PAGER.ITEMCOUNT;
                }
                $scope.status.groupNewsPage = data.PAGER;
            });
        }

        /**
         * [addDraftToTag description]给指定标签增加稿件
         */
        function addDraftToTag(result) {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_specialgroup',
                methodname: 'addDataFromSpecialGroup',
                mediaType: 2, // 便于后端与app渠道做出区分
                MetaDataIds: trsspliceString.spliceString(result, 'METADATAID', ','),
                SpecialGroupId: $scope.status.tag.currTagId,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                deferred.resolve();
            });
            return deferred.promise;
        }

        /**
         * [selectCurrTag description]选择标签
         * @param {[obj]} item [description] 所选的标签
         */
        $scope.selectCurrTag = function(item, index) {
            $scope.status.tag.currTagId = item.SPECIALGROUPID;
            $scope.status.tag.currTagIndex = index;
            resetSortFilter();
            requestTagDraftList(1);
        };

        /**
         * [initRelNewsArray description] 获取选中的分组新闻下的所有稿件
         * @return {[type]} [description]
         */
        function initRelNewsArray() {
            let defer = $q.defer();
            if ($scope.status.groupNewsPage.PAGECOUNT > 1 || $scope.status.isSearch) {
                let relNewsArray = [];
                let params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'querySpecialGroupNewsFromGroup',
                    SpecialGroupID: $scope.status.tag.currTagId,
                    mediaType: 2,
                    CurrPage: 1,
                    PageSize: $scope.data.itemTotal
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    relNewsArray = data.DATA || data;
                    relNewsArray = $filter('unique')(relNewsArray, 'NEWSSPECIALDATAID');
                    angular.forEach(relNewsArray, function(data, index) {
                        data.METADATAID = data.NEWSSPECIALDATAID;
                        data.TITLE = data.DOCTITLE;
                    });
                    defer.resolve(relNewsArray);
                });
            } else {
                defer.resolve(angular.copy($scope.data.groupNews));
            }
            return defer.promise;
        }

        /**
         * [chooseDraftWindow description]选择稿件窗口
         */
        $scope.chooseDraftWindow = function() {
            initRelNewsArray().then(function(selectedDoc) {
                trsSelectDocumentService.trsSelectDocument({
                    siteid: $state.params.wzsiteid,
                    relNewsData: selectedDoc,
                    position: $state.params.wzplatform,
                    showMetadaId: true,
                    platform: 7,
                    isExcludeSpecialDoc: true
                }, function(result) {
                    angular.forEach(result, function(value, key) {
                        value.METADATAID = value.metadataId;
                        value.TITLE = value.title;
                    });
                    // 给标签加稿件
                    addDraftToTag(result).then(function() {
                        // 刷新稿件列表
                        if ($scope.status.isSearch) {
                            $scope.data.itemTotal += result.length;
                        }
                        requestTagDraftList(1);
                    });
                });
            })
        };

        /**
         * [clearDraft description]清空稿件
         * @return {[type]} [description]
         */
        $scope.clearDraft = function() {
            modalDialog.confirmModal('清空稿件', '是否确定清空当前分组下所有稿件？', function() {
                var params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'cleanUpRelateDoc',
                    MetaDataId: $scope.list.METADATAID,
                    SpecialGroupID: $scope.status.tag.currTagId
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType('', '稿件清空成功', 'success');
                    requestTagDraftList(1);
                })
            })
        }

        /**
         * [removeTagDraft description]取消所选标签稿件
         */
        $scope.removeTagDraft = function(item, index) {
            modalDialog.alertType('是否在分组中移除该稿件？', '', 'ask', true, () => {
                let params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'deleteNewsFromSpecialGroup',
                    SpecialGroupId: $scope.status.tag.currTagId,
                    MetaDataIds: item.NEWSSPECIALDATAID,
                    mediaType: 2,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    requestTagDraftList();
                });
            });
        };

        /**
         * [markOriginalDraftName description]记录原稿件名
         * @params item [obj] 所选的稿件
         */
        $scope.markOriginalDraftName = function(item) {
            $scope.status.tag.draftOriginalName = item.RTITLE;
        };

        /**
         * [modifyDraftName description]更改稿件名
         * @params item [obj] 所选的稿件
         */
        $scope.modifyDraftName = function(item) {
            if (item.RTITLE == '') {
                item.RTITLE = $scope.status.tag.draftOriginalName;
                return;
            }
            $scope.status.tag.currDraftId = '';
            var params = {
                serviceid: 'mlf_tag',
                methodname: 'updateDocHomeTitle',
                tagId: $scope.status.tag.currTagId,
                metaDataId: item.METADATAID,
                HomeTitle: item.RTITLE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get');
        };

        /**
         * [newTag description]新建标签
         */
        $scope.newTag = function(ev) {
            if (angular.isDefined(ev) && ev.keyCode == 13) {
                $validation.validate($scope.subjectForm.newtagname).success(function() {
                    if ($scope.status.tag.newTagName == '') {
                        return;
                    }
                    var params = {
                        serviceid: 'mlf_specialgroup',
                        methodname: 'addGroupInfoFromData',
                        GroupName: $scope.status.tag.newTagName,
                        MetaDataId: $scope.list.METADATAID,
                        mediaType: 2,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        // $timeout(requestTagList(), 300);
                        $timeout(
                            requestTagList().then(function() {
                                $scope.selectCurrTag($scope.status.tag.tagArray[0], 0);
                            }),
                            300,
                        );
                        $scope.status.tag.newTagName = '';
                    });
                });
            }
        };

        /**
         * [deleteTag description]删除标签
         * @params item [obj] 所选的稿件
         */
        $scope.deleteTag = function(e,item, index) {
            e.stopPropagation();
            modalDialog.confirmModal('删除标签', '您确定删除此标签', function() {
                var params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'deleteSpecialGroupFromData',
                    MetaDataId: $scope.list.METADATAID,
                    mediaType: 2,
                    SpecialGroupIds: item.SPECIALGROUPID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.deleteSpecialGroupIds = !$scope.data.deleteSpecialGroupIds ? item.SPECIALGROUPID : $scope.data.deleteSpecialGroupIds + ',' + item.SPECIALGROUPID;
                    $timeout(
                        requestTagList().then(function() {
                            var deleteOther = false;
                            var selectedIndex;
                            if ($scope.status.tag.tagArray.length > 0) {
                                for (var i = 0; i < $scope.status.tag.tagArray.length; i++) {
                                    if ($scope.status.tag.tagArray[i].SPECIALGROUPID == $scope.status.tag.currTagId) {
                                        deleteOther = true;
                                        selectedIndex = i;
                                        break;
                                    }
                                }
                                if (deleteOther === false) {
                                    selectedIndex = angular.isDefined($scope.status.tag.tagArray[index]) ? index : index - 1;
                                }
                                $scope.selectCurrTag($scope.status.tag.tagArray[selectedIndex], selectedIndex);
                            } else {
                                $scope.status.tag.currTagId = '';
                            }
                        }),
                        300,
                    );
                    if (item.SPECIALGROUPID == $scope.status.tag.currTagId) {
                        $scope.status.tag.currTagId = '';
                        $scope.status.tag.currDraftId = '';
                    }
                });
            });
            window.event.stopPropagation();
        };

        /**
         * [modifyTagName description]更改标签名
         * @params item [obj] 所选的稿件
         */
        $scope.modifyTagName = function(e, item) {
            e.stopPropagation();
            var originalName = item.SPECIALGROUPNAME;
            editingCenterService.modifyName(item.SPECIALGROUPNAME, function(result) {
                if (result == originalName) {
                    return;
                }
                var params = {
                    serviceid: 'mlf_specialgroup',
                    methodname: 'editSpecialGroupName',
                    ObjectId: item.SPECIALGROUPID,
                    MetaDataId: angular.isDefined($state.params.wzchnldocid) ? $state.params.wzmetadataid : '0',
                    GroupName: result,
                    mediaType: 2,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                    requestTagList();
                });
            });
        };

        /**
         * [chooseAscription description]选择稿件归属人
         */
        $scope.chooseAscription = function() {
            websiteService.ascriptionModel($scope.data.ownerSelectedItems, function(result) {
                $scope.data.ownerSelectedItems = result.selectedArray;
            });
        };
        /**
         * [deleteAscription description] 删除稿件归属人
         * @param  {[type]} index [description] 序列
         * @return {[type]}       [description]
         */
        $scope.deleteAscription = function(index) {
            $scope.data.ownerSelectedItems.splice(index, 1);
        };

        /**
         * [getComment description]获取评审意见
         * @return {[type]} [description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function(data) {
                if (
                    angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                    $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                    $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
                ) {
                    $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                    $scope.data.comment.comment.length - 1
                        ].times.concat(data.comment[0].times);
                    data.comment.shift();
                }
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [getVersion description]获取流程版本与操作日志app新闻
         * @return {[type]} [description]
         */
        function getVersion() {
            messagePublishService.publish('showSubjectOperLog', $scope.list.METADATAID);
        }

        /**
         * [trustUrl description]信任url
         */
        $scope.trustUrl = $sce.trustAsResourceUrl;

        /**
         * [updateCKSelection description]切换checkbox
         * @param  {[string]} attribute [description]需要切换的属性
         * @return {[type]}           [description]
         */
        $scope.updateCKSelection = function(attribute) {
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };

        /**
         * [loadDirective description] 加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            var draftList =
                '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        }

        /**
         * [initDocgenre description]初始化稿件体裁
         * @return {[type]} [description]
         */
        function initDocgenre(obj) {
            iWoService.initData().then(function(data) {
                $scope.data.docGenre = data.DocGenre;
                $scope.list.DOCGENRE = angular.isDefined(obj) ? obj.DOCGENRE : angular.copy($scope.data.docGenre[0]);
            });
        }

        /**
         * [newsDocUpAndDownRecord description]
         *
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  flag  [flag description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.newsDocUpAndDownRecord = function(item, flag) {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_specialgroup',
                methodname: flag === 'up' ? 'upNews' : flag === 'down' ? 'downNews' : 'putOnTop',
                SpecialGroupId: $scope.status.tag.currTagId,
                ObjectId: item.NEWSSPECIALDATAID,
                mediaType: 2,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                if ($scope.status.timeScreen) {
                    resetSortFilter();
                    modalDialog.alertType('移动成功，其他稿件已重置为默认排序', '', 'info', false);
                }
                requestTagDraftList();
                defer.resolve();
            });
            return defer.promise;
        };

        /**
         * [queryByTime description] 时间筛选
         *
         * @return  {[type]}        [return description]
         */
        $scope.queryByTime = function() {
            if ($scope.status.isSearch) {
                return;
            }
            if ($scope.status.timeScreen === '') {
                $scope.status.timeScreen = 'desc'; // 表示 降序
                $scope.status.timeShowFlag = 'DOCFIRSTPUBTIME DESC';
            } else if ($scope.status.timeScreen === 'desc') {
                $scope.status.timeScreen = 'asc'; // 表示升序
                $scope.status.timeShowFlag = 'DOCFIRSTPUBTIME ASC';
            } else {
                resetSortFilter();
            }
            requestTagDraftList(1);
        };

        /**
         * [resetSortFilter description] 排序字段重置
         *
         * @return  {[type]}   [return description]
         */
        function resetSortFilter() {
            $scope.status.timeScreen = ''; // 默认顺序
            $scope.status.timeShowFlag = '';
        }

        /**
         * [compare description]
         *
         * @param   {[type]}  valueA  [valueA description]
         * @param   {[type]}  valueB  [valueB description] 1 降序 -1 升序
         *
         * @return  {[type]}          [return description]
         */
        function compare(valueA, valueB) {
            let pubTimeA = valueA.DOCFIRSTPUBTIME;
            let pubTimeB = valueB.DOCFIRSTPUBTIME;
            if (pubTimeA < pubTimeB) {
                return -1;
            } else if (pubTimeA > pubTimeB) {
                return 1;
            } else {
                return 0;
            }
        }

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            requestTagDraftList();
        };

        /**
         * [pageChanged description]页码跳转
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestTagDraftList();
        };

        /**
         * [fullTextSearch description]检索
         * @param   {[type]}  ev  [ev description]按下回车也能提交
         * @return  {[type]}      [return description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                if(!$scope.status.tag.tagArray.length) {
                    modalDialog.alertType('检索失败，请首先选择一个分组', '', 'warning', false);
                    return;
                }
                $scope.data.groupNews = [];
                if ($scope.keywords.trim() === '') {
                    $scope.status.isSearch = false;
                } else {
                    $scope.status.isSearch = true;
                }
                requestTagDraftList(1);
            }
        };
    },
]);
